import { MEDIA_QUERIES, SELECTORS } from '../utils/constants';

let isSwatchesInitialized = false;

const initProductCardSwatches = () => {
  if (isSwatchesInitialized) return;

  // Cache the MediaQueryList but read .matches per event — hover capability can
  // change mid-session (hybrid devices, devtools emulation), and .matches stays live.
  const touchMediaQuery = window.matchMedia(MEDIA_QUERIES.TOUCH_DEVICE);
  const isTouchDevice = () => touchMediaQuery.matches;

  let activeSwatch = null;

  const showVariantImage = (productCardImageEl, variantImage) => {
    if (!productCardImageEl.dataset.originalSrc) {
      productCardImageEl.dataset.originalSrc = productCardImageEl.src;
      productCardImageEl.dataset.originalSrcset = productCardImageEl.srcset;
    }
    productCardImageEl.src = variantImage;
    productCardImageEl.srcset = '';
  };

  const restoreOriginalImage = (productCardImageEl) => {
    activeSwatch = null;
    if (!productCardImageEl.dataset.originalSrc) return;
    productCardImageEl.src = productCardImageEl.dataset.originalSrc;
    productCardImageEl.srcset = productCardImageEl.dataset.originalSrcset;
    delete productCardImageEl.dataset.originalSrc;
    delete productCardImageEl.dataset.originalSrcset;
  };

  const showVariantPreview = (productCard, swatch) => {
    const productCardImageEl = productCard.querySelector(SELECTORS.PRODUCT_CARD_IMAGE);
    const variantImage = swatch.dataset.productSwatchImage?.trim();
    if (!productCardImageEl || !variantImage) return false;

    showVariantImage(productCardImageEl, variantImage);
    return true;
  };

  const markSelectedSwatch = (containerEl, selectedSwatchEl) => {
    const swatchEls = containerEl.querySelectorAll(SELECTORS.PRODUCT_SWATCH);
    swatchEls.forEach((swatchEl) => {
      const isSelected = swatchEl === selectedSwatchEl;
      swatchEl.classList.toggle('outline-charcoal', isSelected);
      swatchEl.classList.toggle('outline-transparent', !isSelected);
      swatchEl.toggleAttribute('data-swatch-selected', isSelected);
    });
  };

  // On touch devices the first tap previews the variant image; a second tap
  // on the selected swatch follows the link to the PDP.
  document.addEventListener('click', (event) => {
    if (!isTouchDevice()) return;

    const swatch = event.target.closest(SELECTORS.PRODUCT_SWATCH);
    if (!swatch) return;

    if (swatch.hasAttribute('data-swatch-selected')) return;

    const container = swatch.closest(SELECTORS.PRODUCT_SWATCH_CONTAINER);
    const productCard = swatch.closest(SELECTORS.PRODUCT_CARD);
    if (!container || !productCard) return;

    // preventDefault is deliberately gated on a successful preview: a swatch
    // without a preview image falls through to normal link navigation.
    if (!showVariantPreview(productCard, swatch)) return;

    event.preventDefault();
    markSelectedSwatch(container, swatch);
  });

  document.addEventListener('mouseover', (event) => {
    if (isTouchDevice()) return;

    const swatch = event.target.closest(SELECTORS.PRODUCT_SWATCH);
    if (!swatch) return;

    // mouseover fires on every descendant — skip if still inside the same swatch.
    if (swatch === activeSwatch) return;

    const productCard = swatch.closest(SELECTORS.PRODUCT_CARD);
    if (!productCard) return;

    if (!showVariantPreview(productCard, swatch)) return;

    activeSwatch = swatch;
  });

  document.addEventListener('mouseout', (event) => {
    if (isTouchDevice()) return;

    const container = event.target.closest(SELECTORS.PRODUCT_SWATCH_CONTAINER);
    if (!container) return;

    if (container.contains(event.relatedTarget)) return;

    const productCard = container.closest(SELECTORS.PRODUCT_CARD);
    const productCardImageEl = productCard?.querySelector(SELECTORS.PRODUCT_CARD_IMAGE);
    if (productCardImageEl) restoreOriginalImage(productCardImageEl);
  });

  isSwatchesInitialized = true;
};

export default initProductCardSwatches;
